<template>
  <div class="div-swiper-teacher">
    <swiper :options="options" class="swiper-no-swiping">
      <template>
        <swiper-slide id="index" v-for="item in imgs" :key="item.description">
          <div class="divImg">
            <img :src="item.headerImage.url" style="height: 199px" class="divPeople"/>
            <div class="divTitle">{{ item.name }}</div>
            <div class="divSubTitle">
              <img src="../img/vip.png"/>
              {{ item.quarters }}
            </div>
            <div class="divDesc">
              <ul>
                <li
                  v-for="(v, index) in dataConvert(item.details)"
                  :key="index"
                >
                  {{ v }}
                </li>
              </ul>
            </div>
          </div>
        </swiper-slide>
      </template>
      <template>
        <div
          class="swiper-button-prev"
          slot="button-prev"
          @click="swiperList()"
        >
          <div class="card-carousel--nav__left"></div>
        </div>
        <div
          class="swiper-button-next"
          slot="button-next"
          @click="swiperList()"
        >
          <div class="card-carousel--nav__right"></div>
        </div>
      </template>
    </swiper>
  </div>
</template>

<script>
export default {
  data() {
    return {
      options: {
        watchSlidesProgress: true,
        slidesPerView: "auto",
        centeredSlides: true,
        loop: true,
        loopedSlides: 5,
        autoplay: false,
        navigation: {
          nextEl: ".swiper-button-prev",
          prevEl: ".swiper-button-next",
        },
        on: {
          progress: function() {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              var slideProgress = this.slides[i].progress;
              if (Math.abs(slideProgress) > 1) {
                var modify = (Math.abs(slideProgress) - 1) * 0.3 + 1;
              }
              var translate = slideProgress * modify * 430 + "px";
              var scale = 1 - Math.abs(slideProgress) / 5;
              var zIndex = 999 - Math.abs(Math.round(10 * slideProgress));
              slide.transform(
                "translateX(" + translate + ") scale(" + scale + ")"
              );
              slide.css("zIndex", zIndex);
              slide.css("opacity", 1);
              if (Math.abs(slideProgress) > 3) {
                slide.css("opacity", 0);
              }
            }
          },
          setTransition: function(transition) {
            for (var i = 0; i < this.slides.length; i++) {
              var slide = this.slides.eq(i);
              slide.transition(transition);
            }
          },
        },
      },
    };
  },
  props: {
    imgs: {
      type: Array,
      default: function() {
        return [
          {
            title: "",
            subTitle: "",
            description: "",
            url: "",
            image: {
              url: "",
            },
          },
        ];
      },
    },
  },
  methods: {
    swiperList() {
      this.$trackEvent("左右切换", "点击", "左右切换");
    },
    dataConvert(data) {
      let arr = [];
      if (data) {
        data.split("。").forEach((item) => {
          if (item.trim()) {
            arr.push(item + "。");
          }
        });
      }
      return arr;
    },
  },
};
</script>

<style lang="scss">
//样式引入不能scope,不然不生效
@import "../scss/techerDisplayWidge.scss";
</style>
